<script>
	import listBase from '@_system/components/base/list.vue'
	import addIndex from './add/index.vue'
	export default {
		extends: listBase,
		name: 'supplierscoreIndex',
		props: {
			supplier: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				moduleName: 'supplierscore',
				windowName: '供应商积分',
				//windowType: 'window',
				exportData: [],
				loading: false,
				currentrow:null,
				scoretype:'deduct',
				showCancel:false
			}
		},
		render(h) {
			this.$slots.mainheader = [
				<el-switch style="padding-left:20px" v-model={this.showCancel} onChange={this.cancelChange} active-text="显示作废" inactive-text=""></el-switch>,
			]
			this.$slots.plug = [ 
				<add-index currentrow={this.supplier} ref="scoreaddIndex" scoretype={this.scoretype} onSuccess={this.scoresubmit} />
			]
			return listBase.render.call(this, h)
		},
		watch: {

		},
		computed: {
			// device() {
			// 	return window.systemMethods.device()
			// }
		},
		created() {

		},
		mounted() {
			// this.foreingKey = {
			// 	scoresupplierid:this.supplier.id
			// }
		},
		methods: {
			cancelChange(e){
				this.foreingKey.showCancel = e?1:0
				this.customreload()
			},
			// beforeCreateGrid(formConfig, columns, gridOptions){
			// 	formConfig.enabled = false
			// 	gridOptions.pagerConfig.enabled = false
			// },
			bonus(){
				this.scoretype = 'bonus'
				this.$refs.scoreaddIndex.modal_show()
			},
			deduct(){
				this.scoretype = 'deduct'
				this.$refs.scoreaddIndex.modal_show()
			},
			scoresubmit(){
				this.customreload()
			},
			drop(row){
				this.$confirm('是否确认作废').then(()=>{
					this.$api.supplierscore.cancelscore({
							id:row.id,
							scoresupplierid:row.scoresupplierid,
							//supplierid:this.supplier?this.supplier.id:null,
						}).then(()=>{
						this.customreload()
					})
				})
			}
		},
		components: {
			addIndex
			
		}
	}
</script>